import { Component, OnInit } from '@angular/core';
import { MasterService } from 'src/app/services/master/master.service';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ConfirmationDialogService } from 'src/app/_utils/confirmation-dialog/confirmation-dialog.service';
import { ImportFilesDialogService } from 'src/app/_utils/import-files-dialog/import-files-dialog.service';
import { LogsService } from 'src/app/services/adminlogs/logs.service';
import { BaseComponent } from '../../base.component';
@Component({
  selector: 'app-industrymaster',
  templateUrl: './industrymaster.component.html',
  styleUrls: ['./industrymaster.component.css']
})
export class IndustrymasterComponent extends BaseComponent implements OnInit {
  p = 1;
  ord = true;
  colname: "Name";
  text;
  today: number = Date.now();
  public industryTypeObj: any = [];
  constructor(
    private master: MasterService,
    private ImportFilesDialogService: ImportFilesDialogService,
  ) {
    super();
  }
  chgord(col) {
    this.ord = !this.ord
    this.colname = col
  }
  ngOnInit() {
    this.getIndustryData()
    this.IndustryLogData()
  }
  IndustryLogData() {
    let IndustryLogs = {
      log_type:"Industry Master View" ,
      log_name:"Industry Master View" ,
      log_description:"Industry Master View" ,
      moduleid:1 ,
      moduleitemid:7,
      per_id:14
    }
    this.logs.addNewLogs(IndustryLogs).subscribe(data => {
     // console.log(data);

    }, error => {
     // console.log(error);
    });

}
  getIndustryData() {
    let self = this;
    this.ngxSpinnerService.show();
    this.master.getIndustry().subscribe(data => {
      self.industryTypeObj = data;
      this.ngxSpinnerService.hide();
    }, error => {
      console.log(error);
      this.ngxSpinnerService.hide();
    });
  }
  editIndustry(id) {
    this.router.navigate(['/corporate/addnewindustry'], { queryParams: { industry_id: id } });
  }
  deleteIndustry(id) {
    let obj = {
      id: id
    }
    this.confirmationDialogService.confirm('PLEASE CONFIRM', 'Are you sure you want to Delete ?', 'Yes', 'No')
      .then((confirmed) => {
        if (confirmed) {
          this.ngxSpinnerService.show();
          this.master.delIndustry(obj).subscribe(data => {
            if (data.status) {
              this.getIndustryData();
              setTimeout(() => {
                this.toastrService.success("Deleted Successfully");
              }, 1000)
            } else {
            }
            this.ngxSpinnerService.hide();
          }, error => {
            this.toastrService.error(error.message);
          });
        }
      }).catch(() => console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)'));
  }

  updateStatus(event, id) {
    event.preventDefault();
    let obj = this.industryTypeObj.find(element => {
      //console.log(element.get_master_company_type.company_type_id)
      if (element.get_master_industry.industry_id === id) {
        return true;
      }
    });
    obj = obj.get_master_industry
    this.confirmationDialogService.confirm('PLEASE CONFIRM', 'Are you sure you want to change the status?', 'YES', 'NO')
      .then((confirmed) => {
        if (confirmed) {
          this.ngxSpinnerService.show();
          obj.isactive = !obj.isactive;
          this.master.updateIndustry(obj).subscribe(data => {
            this.toastrService.success("Status Changed Successfully");
            this.getIndustryData();
            this.ngxSpinnerService.hide();
          });
        }
        // else {
        //   this.master.updateIndustry(obj).subscribe(data => {
        //     // console.log(data)

        //     setTimeout(() => {
        //       this.toastrService.success("Status Changed Successfully");
        //     }, 1000)
        //     this.getIndustryData();
        //   });
        // }
      }).catch(() => {
      //  console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)')
      });
  }
  setValue(event) {
    let self = this;
    let url = event.target.src;
    if (url.indexOf("master_images") > 0) {
      url = url.substring(url.indexOf("master_images"), url.length)
      if (!this.isUrlValid(url)) {
        let awsUrl = self.master.getUrlfile(url);
        event.target.src = self.isUrlValid(awsUrl) ? awsUrl : '../../../assets/custom/images/broken.png';
      } else {
        event.target.src = '../../../assets/custom/images/broken.png';
      }
    } else {
      event.target.src = '../../../assets/custom/images/broken.png';
    }
    event.target.onerror = null;
  }
  isUrlValid(userInput) {
    return /(https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/i.test(userInput);
  }
  importFile() {
    let self = this;
    this.ImportFilesDialogService.confirm('Please Choose the File Path ', `../../../assets/margo-import-files/margo-industry-import.csv`, 'addingIndustryBulk')
      .then(data => {
      //  console.log(data);
        self.getIndustryData();
      })
      .catch(err => {
      //  console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)')
      })
  }
  exportFile() {
    let tablename = {
      "tableName": "master_industry"
    }
   // console.log(tablename);
    this.master.exportBulk(tablename).subscribe(dataFile => {
      if (dataFile.status) {
        let selBox = document.createElement('a');
        var att = document.createAttribute("href");
        att.value = dataFile.file;
        var att1 = document.createAttribute("download");
        selBox.setAttributeNode(att);
        selBox.setAttributeNode(att1);
        document.body.appendChild(selBox);
        selBox.click();
      }
    }, err => {
      this.toastrService.error(err.message);
    });
  }
}
